var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevrondown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7197 7.90901C19.0126 7.61612 19.4874 7.61612 19.7803 7.90901C20.0732 8.2019 20.0732 8.67678 19.7803 8.96967L12.25 16.5L4.71967 8.96967C4.42678 8.67678 4.42678 8.2019 4.71967 7.90901C5.01256 7.61612 5.48744 7.61612 5.78033 7.90901L12.25 14.3787L18.7197 7.90901Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevrondown);
export default __webpack_public_path__ + "static/media/Chevron down.667fdb168b5c5af86aa84e077030d74f.svg";
export { ForwardRef as ReactComponent };